export default __webpack_public_path__ + "static/media/spooky_hill_background_l1.729aa9a7.jpg";